import React from 'react'
import PropTypes from 'prop-types'

import i18n from './../../../config/i18n'

import { contactProps } from './propTypes'

import { TopSectionTitle } from '../TopSectionTitle/TopSectionTitle'
import ContactCard from './ContactCard/ContactCard'
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary'

import './Contacts.css'

const Contacts = ({ title = i18n.t('contactSection.title'), contactList, dark = false }) => (
    <>
        <TopSectionTitle title={title} underlined centered dark={!dark} />
        <ErrorBoundary>
            <div className="contacts">
                {contactList.map((item, index) => (
                    <ContactCard contact={item} key={index} dark={dark} />
                ))}
            </div>
        </ErrorBoundary>
    </>
)

Contacts.propTypes = {
    title: PropTypes.string,
    contactList: PropTypes.arrayOf(contactProps),
    dark: PropTypes.bool
}

export { Contacts }
